import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/authApi';

export default function RegisterPage() {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const response = await authApi.register(username);
    
    if (response.success) {
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } else {
      setError(response.message || 'Ошибка регистрации');
    }
  };

  return (
    <article className="mx-auto h-[calc(100vh-190px)] flex items-center justify-center w-0 flex-1 flex-col gap-6 py-10">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-3xl shadow">
        <div>
          <p className="mt-6 text-center text-base font-light text-gray-600">
            Регистрация в <span className="font-medium">parallel.one</span>
          </p>
        </div>
        <form className="mt-5 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="text-red-500 text-sm text-center">{error}</div>
          )}
          {success && (
            <div className="text-green-500 text-sm text-center">
              Вы успешно зарегистрировались. Письмо с паролем направлено на почту
            </div>
          )}
          <div className="shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">
                Электронная почта
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className="appearance-none rounded-3xl relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
                placeholder="Электронная почта"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="mb-8 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-3xl text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Зарегистрироваться
            </button>
            <p className="text-center text-base font-light font-light text-gray-600">
              Уже есть аккаунт? 
              <a className="pl-1 font-medium text-gray-600 hover:underline" href="/login">Войти</a>
            </p>
          </div>
        </form>
      </div>
    </article>
  );
} 